module.exports = __webpack_public_path__ + "src/assets/images/login/customers/CNHI_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/customers/CNHI_logo.jpg
// module id = 2314
// module chunks = 4